import React from 'react'

// material ui
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

// data
import { useBrand } from 'components/shared/SettingsProvider'
import { useAppSettings } from 'components/shared/SettingsProvider'

const MinAgeEligibility = props => {
  const { children } = props
  const { shortName, marcomUrl, id: brandId, name: brandName } = useBrand()
  const { minAgeFirstDay } = useAppSettings()

  // Science Factory specific age requirement
  if (brandId === 'sciencefactory') {
    return (
      <Card>
        <CardContent>
          {children}
          <Typography fontWeight='fontWeightBold' color='error.main'>
            All campers must be {minAgeFirstDay} years old by their first day of{' '}
            {brandName}.
          </Typography>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent>
        {children}
        <Typography paragraph fontWeight='fontWeightBold'>
          For most locations,{' '}
          <Typography
            fontWeight='fontWeightBold'
            color='error.main'
            component='span'
          >
            campers must be at least {minAgeFirstDay} years old{' '}
          </Typography>
          and fully toilet trained on their first day of camp.
        </Typography>
        <Typography paragraph>
          <strong>
            In CO, FL, GA, NV, OH, PA, RI, TN and VA the minimum age is 5 and
            there may be an additional education requirement.
          </strong>{' '}
          Please see{' '}
          <Link href={`${marcomUrl}/locations`} target='_blank'>
            Summer
          </Link>{' '}
          or{' '}
          <Link href={`${marcomUrl}/winter-spring-camps/`} target='_blank'>
            Holiday
          </Link>{' '}
          locations on our website for details.
        </Typography>

        <Typography paragraph>
          All campers enrolled in {shortName} must be fully toilet trained
          before attending camp. Please see our full{' '}
          <Link
            href='https://docs.google.com/document/d/e/2PACX-1vTTSrfVcKlrECVZZw8UjIdp5ejzeBadGeh_jnZxZyEjvxGFT_OX6Pn0nTNwAcJsubfAafiOOHsXxCJ0/pub'
            target='_blank'
          >
            Toilet Training Policy
          </Link>{' '}
          to ensure your child meets all requirements before completing
          registration.
        </Typography>
        <Typography>
          Please feel free to{' '}
          <Link href={`${marcomUrl}/contact/`} target='_blank'>
            contact us
          </Link>{' '}
          to help understand if our all-ages environment and unique programming
          is right for your child.
        </Typography>
      </CardContent>
    </Card>
  )
}

export default MinAgeEligibility
